import { IApplicationState } from '../../types';
import { createSelector } from 'reselect';
import { showroundModalInitialState } from '@bridebook/web/lib/showrounds/state/slice';

const getShowroundModalState = (state: IApplicationState) =>
  state.showround ?? showroundModalInitialState;

export const getIsShowroundModalOpen = createSelector(
  getShowroundModalState,
  (state) => state.isOpen ?? false,
);

export const getCalendarIdFromUrl = createSelector(
  getShowroundModalState,
  (state) => state.calendarIdFromUrl,
);

export const getShowroundSupplierContext = createSelector(
  getShowroundModalState,
  (state) => state.supplierContext,
);

export const getShowroundSupplierContextId = createSelector(
  getShowroundSupplierContext,
  (supplier) => supplier?.id,
);
export const getShowroundSupplierContextTimezone = createSelector(
  getShowroundSupplierContext,
  (supplier) => supplier?.l10n?.timezone,
);

export const getShowroundAnalyticsContext = createSelector(
  getShowroundModalState,
  (state) => state.analyticsContext,
);

export const getShowroundDefaultDate = createSelector(
  getShowroundModalState,
  (state) => state.defaultDate,
);
